<div class="lesson-game" *ngIf="game">
  <span class="lesson-game__kicker">Activity — {{gameTypeLabel}}</span>
  <h3 class="lesson-game__title">{{game.title}}</h3>

  <app-match-game *ngIf="game.gameType === 'match'" [game]="game" (attempted)="onAttempted($event)"></app-match-game>
  <app-sequence-game *ngIf="game.gameType === 'sequence'" [game]="game" (attempted)="onAttempted($event)"></app-sequence-game>
  <app-flashcard-game *ngIf="game.gameType === 'flashcard'" [game]="game" (attempted)="onAttempted($event)"></app-flashcard-game>
</div>
